var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemUpTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0039 6.99316C28.2767 6.99341 35.0068 13.7242 35.0068 21.9971C35.0067 30.2698 28.2766 36.9998 20.0039 37C11.731 37 5.00016 30.2699 5 21.9971C5 13.7241 11.7309 6.99316 20.0039 6.99316ZM15.5146 16.0566C15.1142 15.6554 14.465 15.6552 14.0635 16.0566C13.662 16.457 13.6622 17.1073 14.0635 17.5078L16.71 20.1543C16.4019 20.702 16.2109 21.3251 16.2109 21.9971C16.2111 24.0883 17.9127 25.7891 20.0039 25.7891C22.095 25.7888 23.7957 24.0881 23.7959 21.9971C23.7959 19.9059 22.0951 18.2043 20.0039 18.2041C19.3319 18.2041 18.7088 18.3951 18.1611 18.7031L15.5146 16.0566ZM20.0039 20.2578C20.9621 20.2581 21.7422 21.0388 21.7422 21.9971C21.742 22.954 20.962 23.7341 20.0039 23.7344C19.0456 23.7344 18.2648 22.9553 18.2646 21.9971C18.2646 21.0387 19.0455 20.2578 20.0039 20.2578ZM22.9023 3C23.4692 3 23.9294 3.45954 23.9297 4.02637C23.9297 4.59342 23.4694 5.05371 22.9023 5.05371H17.1035C16.5365 5.05371 16.0762 4.59342 16.0762 4.02637C16.0764 3.45954 16.5366 3 17.1035 3H22.9023Z",
    fill: "#53C3EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUpTime);
export default __webpack_public_path__ + "static/media/systemUpTime.82eb222b440dd441b85ff1c53eb601cf.svg";
export { ForwardRef as ReactComponent };